import {
  Box,
  ChevronDownBigIcon,
  Collapsible,
  constants,
  Text,
} from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import Image from 'next/legacy/image';
import React from 'react';
import styles from './Coupon.module.scss';
import couponIcon from './coupon.svg';
import { couponMessages } from './messages';

const CouponOrGiftCardTrigger = ({
  setDrawerOrAccordionClosed,
  collapsed,
  toggleCollapsible,
  availableCoupons,
}) => {
  // biome-ignore lint/correctness/useHookAtTopLevel: useHookAtTopLevel
  // biome-ignore lint/correctness/useHookAtTopLevel: useHookAtTopLevel
  const intl = useIntl();

  return (
    <button
      type="button"
      onClick={() => {
        toggleCollapsible();
        setDrawerOrAccordionClosed(!collapsed);
      }}
      aria-expanded={!collapsed}
      className={styles.trigger}
    >
      <Box display="flex">
        <Image alt="" layout="fixed" src={couponIcon} width={26} aria-hidden />
        <Box display="flex" flexDirection="column">
          <Text type="body" marginLeft="xs" textAlign={constants.LEFT}>
            {intl.formatMessage(couponMessages.couponGiftCard)}
          </Text>
          {availableCoupons > 0 && (
            <Text
              type="caption"
              marginLeft="xs"
              className={styles.availableCoupons}
              textAlign={constants.LEFT}
            >
              {intl.formatMessage(couponMessages.couponAvailable, {
                count: availableCoupons,
              })}
            </Text>
          )}
        </Box>
      </Box>

      <div className={`${collapsed ? styles.close : styles.open}`}>
        <ChevronDownBigIcon size={constants.MEDIUM} />
      </div>
    </button>
  );
};

type AccordionTriggerProps = {
  children: JSX.Element | JSX.Element[];
  setDrawerOrAccordionClosed: (boolean) => void;
  drawerOrAccordionClosed: boolean;
  availableCoupons: number;
};

export const AccordionTrigger = ({
  children,
  setDrawerOrAccordionClosed,
  drawerOrAccordionClosed,
  availableCoupons,
}: AccordionTriggerProps) => (
  <Collapsible
    display="flex"
    trigger={(triggerProps) =>
      CouponOrGiftCardTrigger({
        setDrawerOrAccordionClosed,
        availableCoupons,
        ...triggerProps,
      })
    }
    defaultCollapsed={drawerOrAccordionClosed}
  >
    {children}
  </Collapsible>
);
